import React from 'react'
import PropTypes from 'prop-types'

import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import List from './List'
import CircularProgress from '@mui/material/CircularProgress'

export default function AutoCompleteSearch({
  handleToggle,
  handleDoubleClick,
  dataList,
  fetchMoreData,
  onChangeSearch,
  search,
  isMoreLoading,
  handleDoubleClickAll,
  handleToggleAll,
  numSelected,
  isSelected,
}) {
  return (
    <form noValidate autoComplete="off">
      <TextField
        id="standard-basic"
        variant="standard"
        placeholder="Rechercher .. "
        style={{ height: '45px', padding: '5px 10px 5px 30px', marginTop: '20px' }}
        onChange={(event) => {
          onChangeSearch(event.target.value)
          event.preventDefault()
        }}
        value={search}
      />
      <SuggestionsListComponent
        dataList={dataList}
        handleToggle={handleToggle}
        handleDoubleClick={handleDoubleClick}
        fetchMoreData={fetchMoreData}
        isMoreLoading={isMoreLoading}
        handleDoubleClickAll={handleDoubleClickAll}
        handleToggleAll={handleToggleAll}
        numSelected={numSelected}
        isSelected={isSelected}
        search={search}
      />
    </form>
  )
}
AutoCompleteSearch.propTypes = {
  handleToggle: PropTypes.func,
  handleDoubleClick: PropTypes.func,
  dataList: PropTypes.array,
  fetchMoreData: PropTypes.func,
  onChangeSearch: PropTypes.func,
  search: PropTypes.string,
  isMoreLoading: PropTypes.bool,
  handleDoubleClickAll: PropTypes.func,
  handleToggleAll: PropTypes.func,
  numSelected: PropTypes.number,
  isSelected: PropTypes.func,
}

export const SuggestionsListComponent = ({
  handleToggle,
  dataList,
  handleDoubleClick,
  fetchMoreData,
  isMoreLoading,
  handleDoubleClickAll,
  handleToggleAll,
  numSelected,
  isSelected,
  search,
}) => {
  return (
    <>
      {isMoreLoading ? (
        <div style={{ marginLeft: '45%' }}>
          <CircularProgress color="primary" />
        </div>
      ) : dataList.length > 0 ? (
        <List
          dataList={dataList}
          handleToggle={handleToggle}
          handleDoubleClick={handleDoubleClick}
          fetchMoreData={fetchMoreData}
          handleDoubleClickAll={handleDoubleClickAll}
          handleToggleAll={handleToggleAll}
          numSelected={numSelected}
          isSelected={isSelected}
          search={search}
        />
      ) : (
        <Typography variant="caption" display="block" gutterBottom>
          Pas de données
        </Typography>
      )}
    </>
  )
}

SuggestionsListComponent.propTypes = {
  filteredSuggestions: PropTypes.array,
  handleToggle: PropTypes.func,
  handleDoubleClick: PropTypes.func,
  dataList: PropTypes.array,
  fetchMoreData: PropTypes.func,
  isMoreLoading: PropTypes.bool,
  handleDoubleClickAll: PropTypes.func,
  handleToggleAll: PropTypes.func,
  numSelected: PropTypes.number,
  isSelected: PropTypes.func,
  search: PropTypes.string,
}
